module.exports = __webpack_public_path__ + "static/htc-236bc78db43a677c31511d99984ad4ff.jpg";